import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-nav">
          <ul>
            <li>
              <a target="_blank" href="https://www.wa.gov.au/">
                wa.gov.au
              </a>
            </li>
            <li>
              <a
                target="_blank"
                id="make_claim_footer_link"
                href="https://www.wa.gov.au/service/business-support/business-accounting-and-reporting/unclaimed-money"
              >
                Need help making a claim?
              </a>
            </li>
            <li>
              <a
                target="_blank"
                id="report_vulnerability_footer_link"
                href="https://www.wa.gov.au/service/business-support/business-accounting-and-reporting/unclaimed-money"
              >
                Report a vulnerability
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
